import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { UiService } from 'src/app/admin/service/ui.service';
import { environment } from 'src/environments/environment';
import { DetailProductComponent } from '../home/components/detail-product/detail-product.component';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  urlMarketplace = `${environment.url}/marketplace`;
  urlCategories = `${environment.url}`;

  constructor(
    private http: HttpClient, 
    private uiSv: UiService,
    private navCtrl: NavController
  ) {}

  getRandomHome() {
    return this.http.get(`${this.urlMarketplace}/home`);
  }

  async openModalProduct(idProduct: number, editing?, nameProduct?) {
    if(editing){
      return;
    }
    this.navCtrl.navigateRoot(`product-detail/${idProduct}`,
      {
        queryParams: {name: nameProduct.trim().replace(/ /g, '-')}
      }
    );
    // const { data, role } = await this.uiSv.createModal(DetailProductComponent, { idProduct }, 'modalDetail')
    // if(role === 'saveQuantity'){
    //   return data;
    // }
  }

  getSearch(
    currentPage,
    search: string = 'todos',
    category: string = 'todos',
    date: string = 'mas-recientes',
    state: string = 'todos',
    promo: string = '0',
    desde: string = '',
    hasta: string = ''
  ) {
    return this.http.get(
      `${this.urlMarketplace}/product/search/${currentPage}/${search}/${category}/${date}/${state}/${promo}/${desde}/${hasta}`
    );
  }

  getCategories() {
    return this.http.get(`${this.urlCategories}/categories/home`);
  }

  getAll() {
    return this.http.get(`${this.urlMarketplace}/product/search/1/todos`);
  }

  getProduct(id, token?) {
    console.log(token);
    
    return this.http.get(`${this.urlMarketplace}/product/show/${id}`, 
    {
      headers: {
        Authorization: `bearer ${token}`
      }
    }
    );
  }

  getStore(id) {
    return this.http.get(`${this.urlMarketplace}/store/show/${id}`);
  }

  user(id) {
    return this.http.get(`${this.urlMarketplace}/user/show/${id}`);
  }

  createProduct(body) {
    return this.http.post(`${this.urlCategories}/product/create`, body);
  }

  editProduct(body) {
    return this.http.post(`${this.urlCategories}/product/update`, body);
  }

  getProductsStoreAdmin(id) {
    return this.http.get(`${this.urlCategories}/product/indexStore/${id}`);
  }

  getProductsStoreClient(id, pag, search?, category?) {
    return this.http.get(
      `${this.urlMarketplace}/store/product/${id}/${pag}${search}${category}`
    );
  }

  getProductsUserClient(id, pag:number) {
    return this.http.get(
      `${this.urlMarketplace}/user/product/${id}/${pag}`
    );
  }

  getProductsIndividual() {
    return this.http.get(`${this.urlCategories}/product/index`);
  }

  deleteProduct(id) {
    return this.http.post(`${this.urlCategories}/admin/product/delete`, id)
  }

  deleteImage(body) {
    return this.http.post(`${this.urlCategories}/product/deleteImg`, body);
  }

  postReview(body){
    return new Promise(resolve => {
      this.http.post(`${this.urlCategories}/product/add/review/create`, body)
        .subscribe(res => {
          resolve(res);
        }, err => {
          console.error(err);
        })
    })
  }

  saveFavorite(body, type){
    return new Promise(resolve => {
      this.http.post(`${this.urlCategories}/product/add/${type}/create`, body)
        .subscribe(res => {
          resolve(res);
        }, err => {
          console.error(err);
        })
    })
  }

  getComments(productId) {
    return new Promise((resolve, reject) => {
      const params = {
        productId
      }
      this.http.get(`${this.urlCategories}/product/add/comment/index`,
        { params }
      ).subscribe((res) => {
        resolve(res)
      }, err => {
        reject(err)
      });
    })
  }
  
  postComments(body) {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlCategories}/product/add/comment/create`, body).subscribe((res) => {
        resolve(res)
      }, err => {
        reject(err)
      });
    })
  }
}
